import { Icon, IconProps } from '@chakra-ui/react'
import { FC } from 'react'

const DollarCircle: FC<IconProps> = (props) => (
  <Icon
    xmlSpace="preserve"
    id="Layer_1"
    x={0}
    y={0}
    fill="none"
    stroke="phthalo"
    strokeWidth={3}
    viewBox="0 0 41 41"
    boxSize="28px"
    strokeLinecap="round"
    strokeLinejoin="round"
    strokeMiterlimit={10}
    {...props}
  >
    <circle cx={20.5} cy={20.5} r={19} />
    <path d="M13.9 26.5c.6 1.1 2.3 2.8 3.4 3.4 1.1.6 2.3.9 3.6.9 1.6 0 3-.5 4-1.4 1.1-1 1.7-2.2 1.7-3.6s-.5-2.6-1.5-3.5c-.9-.8-2.5-1.6-4.9-2.5-2.7-1-3.9-1.9-4.4-2.5-.7-.8-1-1.8-1-3.2 0-1.2.3-2.2 1.1-2.9 2.9-2.8 8.9-1.8 9.9.7M20.5 6.5v2M20.5 31.5v2" />
  </Icon>
)
export default DollarCircle
